var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _vm._t("default"),
        _c(
          "router-link",
          { staticClass: "btn btn-outline-primary", attrs: { to: "/upgrade" } },
          [
            _c(
              "svg",
              {
                staticClass: "icon icon-tabler icon-tabler-bolt",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  "stroke-width": "2",
                  stroke: "currentColor",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", {
                  attrs: { stroke: "none", d: "M0 0h24v24H0z", fill: "none" },
                }),
                _c("polyline", {
                  attrs: { points: "13 3 13 10 19 10 11 21 11 14 5 14 13 3" },
                }),
              ]
            ),
            _vm._v(" Upgrade Now "),
          ]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }